module.exports = __webpack_public_path__ + "img/members-icon-active.49a4c053.svg";